"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconFolder', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M2 2.5C1.44772 2.5 1 2.94772 1 3.5V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V6C15 5.44772 14.5523 5 14 5H9.48062L7.78087 2.8753C7.5911 2.63809 7.30378 2.5 7 2.5H2ZM6.91937 5L6.51937 4.5H3V5H6.91937ZM3 13V7H13V13H3Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M2 3C1.44772 3 1 3.44772 1 4V17C1 17.5523 1.44772 18 2 18H18C18.5523 18 19 17.5523 19 17V7C19 6.44772 18.5523 6 18 6H11.5352L9.83205 3.4453C9.64658 3.1671 9.33435 3 9 3H2ZM9.13148 6L8.46482 5H3V6H9.13148ZM3 16V8H17V16H3Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M2 4.50002C1.44772 4.50002 1 4.94773 1 5.50002V21C1 21.5523 1.44772 22 2 22H22C22.5523 22 23 21.5523 23 21V9.00002C23 8.44773 22.5523 8.00002 22 8.00002H13.5146L11.3137 4.91878C11.126 4.65598 10.823 4.50002 10.5 4.50002H2ZM11.0568 8.00002L9.98538 6.50002H3V8.00002H11.0568ZM3 20V10H21V20H3Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M3.5 5C2.67157 5 2 5.67157 2 6.5V27.5C2 28.3284 2.67157 29 3.5 29H28.5C29.3284 29 30 28.3284 30 27.5V11.5C30 10.6716 29.3284 9.99999 28.5 9.99999H18.3493L15.7862 5.72826C15.5152 5.27645 15.0269 5 14.5 5H3.5ZM14.8507 9.99999L13.6507 8H5V9.99999H14.8507ZM5 26V13H27V26H5Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;